"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _AvatarContent = _interopRequireDefault(require("./AvatarContent"));

var _AvatarStatus = _interopRequireDefault(require("./AvatarStatus"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var KTTooltip = (0, _styles.withStyles)(function (theme) {
  return {
    tooltip: {
      fontFamily: 'proxima-soft, sans-serif',
      fontSize: '0.825rem',
      backgroundColor: '#516173'
    }
  };
})(_core.Tooltip); // in px

var DIMENSIONS = {
  'xs': 24,
  'sm': 32,
  'md': 40,
  'lg': 48,
  'xl': 56,
  'xxl': 64
};

var Avatar = function Avatar(_ref) {
  var image = _ref.image,
      size = _ref.size,
      initials = _ref.initials,
      status = _ref.status,
      tooltip = _ref.tooltip; // xs and xxl avatars do not support status indicators

  var ignoreStatus = Boolean(size.match(/xs|xxl/i));
  var avatarDimensions = DIMENSIONS[size];
  return _react["default"].createElement(KTTooltip, {
    title: tooltip,
    placement: "right"
  }, _react["default"].createElement("div", {
    style: {
      "float": 'left',
      height: avatarDimensions,
      width: avatarDimensions,
      position: 'relative'
    }
  }, _react["default"].createElement(_AvatarContent["default"], {
    height: avatarDimensions,
    width: avatarDimensions,
    image: image,
    initials: initials
  }), !ignoreStatus && _react["default"].createElement(_AvatarStatus["default"], {
    status: status,
    avatarSize: size
  })));
};

Avatar.propTypes = {
  size: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  status: _propTypes["default"].oneOf(['online', 'busy', 'offline']),
  image: _propTypes["default"].string,
  initials: _propTypes["default"].string,
  tooltip: _propTypes["default"].string
};
Avatar.defaultProps = {
  size: 'sm',
  image: '',
  initials: '',
  tooltip: ''
};
var _default = Avatar;
exports["default"] = _default;